module.exports = __webpack_public_path__ + "static/media/AI模块.a8518835.png";